// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__8osOA","controls":"Navbar_controls__Z0xMy","searchbox":"Navbar_searchbox__7YbPW","link":"Navbar_link__n-9aV"};